(function ($) {
    $(function () {
        /**
         * Regular expression for matching postcodes including named capture
         * groups
         *
         * @type {RegExp}
         */
        const regex = /^(?<outbound>([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z]))))( ?)(?<inbound>[0-9][A-Za-z]{2})$/;

        /**
         * Format a postcode to include a space in the correct location
         *
         * @return void
         */
        const formatPostcode = function(event) {
            // Get value
            let postcode = this.value;

            // Replace multiple whitespace with one, and trim leading and ending
            // whitespace
            let trimmedPostcode = postcode.replace(/[\s]{2,}/g, '').toUpperCase().trim();

            // Test against the regex
            const match = regex.test(trimmedPostcode);
            if (match) {
                const result = trimmedPostcode.match(regex);

                // If we have access to the named matches, we can add a space
                // where required.
                if (result.groups !== undefined) {
                    const outbound = result.groups.outbound;
                    const inbound = result.groups.inbound;

                    this.value = outbound + ' ' +  inbound;
                    return;
                }
            }

            // Change value
            this.value = trimmedPostcode;
        }

        // Attach postcode formatting handler
        const inputs = [
            '#postcode-popup-input',
            '#shipping_postcode',
            '#billing_postcode',
        ];

        inputs.forEach((selector) => {
            const inputs = document.querySelectorAll(selector);

            inputs.forEach((input) => {
                if (input !== null) {
                    $(input).on('change', formatPostcode);
                }
            });
        });
    });
})(jQuery);
